import { useEffect } from 'react';
import './Dashboard.scss';
import Hud from './hud/Hud';
import Monitor from './monitor/Monitor';
import useGenericSimulator from '../../hooks/useGenericSimulator';
import useUrlParams from '../../hooks/useUrlParams';

import { getGrafanaData, getVisualizationElements } from '../../service/GenericSimulatorApi';
import pako from 'pako';
import { VisualizationData } from '../../types';

const Dashboard = () => {
    const { activeTab, grafanaData, setGrafanaData, setVisualizationData, visualizationData } = useGenericSimulator();
    const { mission_id, scenario_id, dashboard } = useUrlParams();
    const isSummary = dashboard === 'summary';
    
    // Fetch Grafana data once when Dashboard mounts
    useEffect(() => {
        if (!mission_id || !scenario_id || grafanaData) return;

        getGrafanaData(mission_id, scenario_id)
            .then((res: any) => {
                setGrafanaData(res?.data ?? null);
            })
            .catch((err: any) => {
                setGrafanaData({ error: true });
            });
    }, [mission_id, scenario_id]); 

    // Fetch visualization elements data in summary mode
    useEffect(() => {
        if (!isSummary || !mission_id || !scenario_id || visualizationData) return;

        getVisualizationElements(mission_id, scenario_id)
            .then((res: any) => {
                const raw = res?.data?.data ?? res?.data;
                try {
                    let parsed: any;

                    // If response is a base64-encoded gzip string, decompress it
                    if (typeof raw === 'string') {
                        const binaryStr = atob(raw);
                        const bytes = new Uint8Array(binaryStr.length);
                        for (let i = 0; i < binaryStr.length; i++) {
                            bytes[i] = binaryStr.charCodeAt(i);
                        }
                        const decompressed = pako.ungzip(bytes, { to: 'string' });
                        parsed = JSON.parse(decompressed);
                    } else {
                        // Already JSON (server may have auto-decompressed)
                        parsed = raw;
                    }

                    // Store in context for useSummaryReplay to consume
                    const vizData: VisualizationData = parsed.data as VisualizationData;
                    setVisualizationData(vizData);
                } catch (err) {
                    // Last-resort: treat raw as VisualizationData directly
                    if (raw?.elements) {
                        setVisualizationData(raw as VisualizationData);
                    }
                }
            })
            .catch((err: any) => {
                console.error('[Dashboard] Failed to fetch visualization elements:', err);
            });
    }, [isSummary, mission_id, scenario_id]); 

    return (
        <div className='gs__dashboard'>
            <div className='gs__dashboard__tab' style={{ display: activeTab === 'hud' ? 'flex' : 'none' }}>
                <Hud />
            </div>
            {activeTab === 'monitor' && <Monitor />}
        </div>
    );
};

export default Dashboard;
